<template>
  <div class="page">
    <FriedCard class="template-page">
      <VideoPage v-if="isPageType(DocumentPageType.Video)" :page="page" />
      <ContentLinkPage
        v-else-if="isPageType(DocumentPageType.ContentLink)"
        :content-link-block="page.contentLinkBlock"
      />
      <PDFPage
        v-else-if="isPageType(DocumentPageType.DocumentContent)"
        class="pdf-page"
        :page="page"
        :page-width="pageWidth"
        :recipients="[]"
      />
      <div v-else-if="isPageType(DocumentPageType.Editor)" class="editor-wrapper">
        <EditorBlockView
          :is-block-toggled="true"
          :merge-values="({} as any)"
          :content="editorContent"
          :context="Context.DocumentView"
          :all-content="allContent"
        />
      </div>
    </FriedCard>
  </div>
</template>
<script lang="ts">
import { EditorBlockView } from '@getaccept/editor-view-new';
import { Context } from '@getaccept/editor-lib-new';
import type { DocumentPage } from '@getaccept/lib-shared-new/src/types/document-page';
import { DocumentPageType } from '@getaccept/lib-shared-new/src/enums/document-page-type';
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import ContentLinkPage from '@getaccept/lib-shared-new/src/components/ContentLinkPage.vue';
import VideoPage from '@getaccept/lib-shared-new/src/components/VideoPage.vue';
import PDFPage from '@getaccept/lib-shared-new/src/document-view/components/PDFPage.vue';

export default defineComponent({
  name: 'Page',
  components: {
    VideoPage,
    ContentLinkPage,
    PDFPage,
    EditorBlockView,
  },
  props: {
    page: { type: Object as PropType<DocumentPage>, required: true },
    pages: { type: Array as PropType<DocumentPage[]>, default: () => [] },
    pageWidth: { type: Number, required: true },
  },
  setup(props) {
    const editorContent = computed(() => props.page.editorBlock.content);

    const isPageType = (pageType: DocumentPageType) => props.page.pageType === pageType;

    const allContent = computed(() =>
      props.pages.filter(page => page.editorBlock).map(page => page.editorBlock.content)
    );

    return {
      DocumentPageType,
      Context,
      editorContent,
      isPageType,
      allContent,
    };
  },
});
</script>
<style scoped lang="scss">
.page {
  position: relative;

  .template-page {
    .editor-wrapper {
      position: relative;
    }

    .pdf-page {
      overflow: hidden;
      border-radius: var(--radius-medium);
    }
  }
}
</style>
